import React from "react";
import { Result } from "@findemdev/maui";
import { matchesUrl } from "@findemdev/findem-helpers";
import { ActionButtons, RefreshButton } from "./ErrorSplash.styled";
import { isChunkLoadError, retryCurrentDocument } from "./chunkLoadRecovery";

interface ErrorSplashProps {
  error?: unknown;
}

const ErrorSplash = ({ error }: ErrorSplashProps) => {
  const chunkLoadError = isChunkLoadError({ error });

  const handleRefresh = React.useCallback(() => {
    if (chunkLoadError) {
      retryCurrentDocument();
      return;
    }

    window.location.reload();
  }, [chunkLoadError]);

  return (
    <Result
      status="500"
      title="It appears you've encountered an error."
      subTitle="An error report is on its way to us. Try refreshing the page. If the problem persists, please contact support. We're here to help!"
      extra={
        <ActionButtons>
          <RefreshButton onClick={handleRefresh} type="primary" size="large">
            Refresh Page
          </RefreshButton>
          <a
            href={`${matchesUrl}/auth/login`}
            target="_blank"
            rel="noopener noreferrer"
          >
            If you&apos;re logged out, login here.
          </a>
        </ActionButtons>
      }
    />
  );
};

export default ErrorSplash;
